import React from 'react';
import {
  cssColorValue,
  desktopBallad,
  TextLinkProps,
} from '@spotify-internal/encore-web-v6';
import styled from 'styled-components';
import { TrackingAttributes } from '@spotify-internal/frodor-modules';
import { FrodorTextLink } from '../../Nav/NavBarLinks';

const StyledFooterTextLink = styled(FrodorTextLink)`
  text-decoration: none !important;
  color: ${cssColorValue('textSubdued')} !important;
  ${() => desktopBallad}
  &:hover {
    text-decoration: none !important;
    color: ${cssColorValue('textBase')} !important;
  }
`;

export type FooterTextLinkType = {
  href: string;
  external?: boolean;
  useInternalNavigation?: boolean; // should only ever be true if there is navigation set in the onLinkClick function
  track: TrackingAttributes;
  dataTestId?: string;
};

export const FooterTextLink = ({
  children,
  href,
  external = false,
  useInternalNavigation = false,
  track,
  dataTestId,
  ...buttonProps
}: FooterTextLinkType & TextLinkProps & { children: React.ReactNode }) => {
  return (
    <StyledFooterTextLink
      track={track}
      href={href}
      useInternalNavigation={useInternalNavigation}
      dataTestId={dataTestId}
      external={external}
      {...buttonProps}
    >
      {children}
    </StyledFooterTextLink>
  );
};
